import { render, staticRenderFns } from "./ViewDDSSummary.vue?vue&type=template&id=9a9dd746&scoped=true"
import script from "./ViewDDSSummary.vue?vue&type=script&lang=js"
export * from "./ViewDDSSummary.vue?vue&type=script&lang=js"
import style0 from "./ViewDDSSummary.vue?vue&type=style&index=0&id=9a9dd746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9dd746",
  null
  
)

export default component.exports